module.exports = __webpack_public_path__ + "media/images/down-arrow-black-5f488bb8c63196ade5d767b4d09c7657.png";